export default {"src":"/_next/static/media/icon-orbital-track.c54ba384.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};